import { useEffect } from 'react';
import ServiceTypesDataTable from './ServiceTypesTable/ServiceTypesDataTable';

function ServiceTypes() {

  // #region Events

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  // #endregion

  // #region Templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Tipos de Servicio
          </h1>
        </section>
        <section>
          <ServiceTypesDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default ServiceTypes;